import { render, staticRenderFns } from "./StudentOvertakeClassAddEdit.vue?vue&type=template&id=4d43d287"
import script from "./StudentOvertakeClassAddEdit.vue?vue&type=script&lang=js"
export * from "./StudentOvertakeClassAddEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports